import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';

import { emotionMapping } from '../../utils/emotions';

const EmotionsList = ({ emotions, onClick, selectedEmotions, loading }) => {
  if (loading) {
    return [1, 2, 3, 4, 5, 6].map(i => (
      <div key={i} className="tvt-reactions__emotions-loading" />
    ));
  }

  if (!emotions) {
    return null;
  }

  const totalVotes = emotions.reduce((total, c) => total + c.votes, 0);

  const onClickEmotion = e => () => onClick(e);

  return (
    <div className="tvt-reactions__emotions-list-wrapper">
      {emotions.map(emotion => (
        <button
          alt="emotion"
          key={emotion.name}
          onClick={onClickEmotion(emotion.name)}
          className={`tvt-reactions__emotions-wrapper ${
            selectedEmotions.includes(emotion.name) ? 'selected' : ''
          }`}
        >
          <div className="tvt-reactions__emotion-name-emoji-wrapper">
            <div className="tvt-reactions__emotion-name-emoji-emoji">
              {emotionMapping[emotion.name]}
            </div>
            <div className="tvt-reactions__emotion-name-emoji-name">
              {emotion.name}
            </div>
          </div>
          <div className="tvt-reactions__emotion-bar-wrapper">
            <div
              style={{
                width: `${Math.floor((emotion.votes / totalVotes) * 100)}%`
              }}
              className="tvt-reactions__emotion-votes-bar"
            />
          </div>
          <div className="tvt-reactions__emotion-votes-wrapper">
            <div>{numeral(emotion.votes).format(',')}</div>
            <div>Reactions</div>
          </div>
        </button>
      ))}
    </div>
  );
};

EmotionsList.propTypes = {
  emotions: PropTypes.arrayOf(PropTypes.shape({})),
  loading: PropTypes.bool.isRequired
};

EmotionsList.defaultProps = {
  emotions: null
};

export default EmotionsList;
